<template>
  <div class="purChase-box">
    <div
    class="purchase-item"
    v-for="(item, index) of purchaseList" :key="index">
      <img :src="item.img" />
    </div>
  </div>
</template>
<script>
const purchaseList = [
  {
    text: '配送到家',
    img: require('@/assets/cake/home/delivery.png')
  },
  {
    text: '到店消费',
    img: require('@/assets/cake/home/shop.png')
  }
]

export default {
  data () {
    return {
      purchaseList
    }
  }
}
</script>
<style lang="scss" scoped>
.purChase-box {
  width: $cake-box-width;
  display: flex;
  justify-content: space-around;
  font-size: 0.28rem;
  margin: 0 auto;
  .purchase-item{
    text-align: center;
    height: 1.91rem;
    width: 3.31rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>